<template>
  <!-- <v-list-item
    class="py-1"
    @click="$emit('click')"
    :input-value="selected"
    color="green"
  >
    <v-list-item-avatar color="primary">
      <v-img v-if="imageUrl" :src="imageUrl"></v-img>
      <v-icon v-else-if="icon" size="24" color="white">{{ icon }}</v-icon>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title> {{ name }} </v-list-item-title>
      <v-list-item-subtitle style="color: #333">
        <template v-if="lastmessage">
          <i :style="{ 'font-weight': boldSubtitle ? 'bold' : 'normal' }">
            {{ lastmessage }}
          </i>
        </template>
        <template v-else> {{ subtitle }} </template>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item> -->
  <div @click="$emit('click')" class="chat-contact d-flex align-center pa-1 cursor-pointer rounded-lg"
    :class="{ 'bg-gradient-primary active-chat-contact': selected }">
    <v-avatar size="32" color="primary">
      <v-img v-if="imageUrl" :src="imageUrl"></v-img>
      <v-icon v-else-if="icon" size="22" color="white">{{ icon }}</v-icon>
    </v-avatar>

    <div class="ml-2 flex-grow-1 overflow-hidden">
      <p class="mb-0 font-weight-medium text--primary">
        {{ name }}
      </p>
      <p class="text--disabled mb-0 text-truncate">
        <template v-if="lastmessage">
          <span :style="{
            'font-weight': boldSubtitle ? 'bold' : 'normal',
            'font-style': boldSubtitle ? 'italic' : 'normal',
          }">
            {{ lastmessage }}
          </span>
        </template>
        <template v-else>
          {{ subtitle }}
        </template>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "id",
    "selected",
    "name",
    "subtitle",
    "imageUrl",
    "icon",
    "lastmessage",
    "boldSubtitle",
  ],
};
</script>

<style></style>
